/// <amd-module name="VSSUI/VssDetailsList" />
export * from "./Components/VssDetailsList/index";
